<template>
    <page-container2 style="flex-direction: column;" title="角色管理" showRefreshBtn @refresh="$refs.pageTable.load()">
         <template v-slot:buttons>
            <permission-container permissionId="System.Role.Add">
                <el-button type="primary" size="mini" @click="add">添加</el-button>
            </permission-container>
        </template>
        <pagination-table ref="pageTable" :tableList="tableList" tablePermissionId="System.Role.List">
            <template v-slot:searchForm>
                <el-form-item label="角色名">
                    <el-input v-model="tableList.searchForm.roleName" placeholder="角色名"></el-input>
                </el-form-item>
            </template>
            <template v-slot:tableColumns>
<!--                <el-table-column-->
<!--                    type="index"-->
<!--                    label="序号"-->
<!--                    width="50"-->
<!--                    align="center"-->
<!--                >-->
<!--                </el-table-column>-->

                <el-table-column
                    prop="name"
                    label="角色名">
                </el-table-column>
                <el-table-column
                    prop="description"
                    label="描述">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.createTime"/>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    label="更新时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.updateTime"/>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180"
                >
                    <template slot-scope="scope">
                        <permission-container permissionId="System.Role.Edit">
                            <el-button
                            size="mini"
                            @click="edit(scope.row, scope.$index)">编辑</el-button>
                        </permission-container>
                    </template>
                </el-table-column>
            </template>
        </pagination-table>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";
export default {
    name: "RoleList",
    data()
    {
        return {
            tableList: new List({url: '/system/role/list'})
        }
    },
    created()
    {
        console.log('list created');
    },
    mounted()
    {
    },
    methods:
    {
        add()
        {
            let bridge = this.dispatchRouteTo('/role/edit');
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        },
        edit(rowData, index)
        {
            console.log(rowData, index);
            let bridge = this.dispatchRouteTo('/role/edit', {id: rowData.id});
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/system/pages/role/List.vue